var scope_0 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0b1ac9f2e363bc5a496e2d2024849aad.js').default;
var scope_1 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/47f654e161f5741d0a1a5462c73d901c.js').default;
var scope_2 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/66cd381c4e4b80f45b6d7f93c0408944.js').default;
var scope_3 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/85faab403ac773b262f72c09ec3eed20.js').default;
var scope_4 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8bf1cffc6ad916d337f994ac6325fc01.js').default;
var scope_5 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a253e54263e4ea117a963bd6195360c0.js').default;
var scope_6 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_7 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f652f6372be58b0e547ef92e35008f93.js').default;
var scope_8 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f78a0e06a66a4ad57474827a318a3540.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8 )
    